import PropTypes from 'prop-types';
import Cookies from 'js-cookie';

const PixelViewContentHandler = function PixelViewContentHandler(props) {
    const {
        charitykey, baseUrl, testeventcode, context,
    } = props;

    const urlParams = new URLSearchParams(window.location.search);
    const fbclId = urlParams.get('fbclid') || '';

    let fbc = Cookies.get('_fbc');

    // fbc cookie not found? We can try and generate it on our own using the given url parameters
    if (!fbc && fbclId) {
        // https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc
        // {version}.{subdomainIndex}.{creationTime}.{fbclid}
        // e.g. fb.1.1554763741205.AbCdEfGhIjKlMnOpQrStUvWxYz1234567890
        fbc = `fb.1.${Math.floor(new Date() / 1000)}.${fbclId}`;
    }

    const fbp = Cookies.get('_fbp');

    // set the cookies for the thank you page to pick up
    // set expiry time to 20 minutes
    // as that's the current time limit on giving creation -> donate form submit.
    const expiry = new Date(new Date().getTime() + 20 * 60 * 1000);

    // set the domain for the current url e.g. ".giveeasy.org" or ".giveeasy.info"
    const { host, protocol } = new URL(baseUrl);
    const hostParts = host.split('.');

    const cookieValue = JSON.stringify({
        fbp, fbc, testeventcode, context,
    });

    // if domain is not localhost and has a subdomain
    if (!host.includes('localhost') || hostParts.length > 2) {
        // note the . before the domain
        Cookies.set('ge_fbpixel', cookieValue, {
            expires: expiry,
            domain: `.${hostParts[hostParts.length - 2]}.${hostParts[hostParts.length - 1]}`,
            path: '/',
        });
    } else {
        // For localhost - cookies can't have domain set
        Cookies.set('ge_fbpixel', cookieValue, { expires: expiry });
    }

    const eventData = {
        FBP: fbp || '',
        FBC: fbc || '',
        CharityKey: charitykey,
        TestEventCode: testeventcode,
        Context: context,
    };

    const httpOptions = {
        method: 'POST',
        body: JSON.stringify(eventData),
        headers: new Headers({ 'content-type': 'application/json' }),
    };

    // request to server endpoint
    // from the server fetch the pixelId and API secret
    // and then send the request to FB conversions API
    fetch(`${protocol}//${host}/api/pixel/viewcontent`, httpOptions);

    return null;
};

PixelViewContentHandler.propTypes = {
    charitykey: PropTypes.string.isRequired,
    context: PropTypes.string.isRequired,
    baseUrl: PropTypes.string,
    testeventcode: PropTypes.string,
};

PixelViewContentHandler.defaultProps = {
    baseUrl: window.location.href,
    testeventcode: '',
};

export default PixelViewContentHandler;
